// extracted by mini-css-extract-plugin
export default {"header":"BrandedHeader_header__k44eo"};